<template>
  <div class="maskBox" @click="close">
    <div class="share" @click.stop>
      <img class="getFreeBox" src="../../assets/images/cashWheel/getFreeBox.webp" alt="">
      <img class="close" src="../../assets/images/cashWheel/close2.png" alt="" @click="close">
      <div class="titleBox">
        <div class="title">{{$t('lang.cashWheel.ShareTo')}}</div>
        <div class="title">{{$t('lang.cashWheel.getOneSpinChance')}}</div>
      </div>
      <div class="shareSloganBox">
        <div class="shareSlogan">{{$t('lang.cashWheel.shareSlogan1')}}</div>
        <div class="shareSlogan">{{$t('lang.cashWheel.shareSlogan2')}}</div>
        <div class="shareSlogan">{{$t('lang.cashWheel.shareSlogan3')}}</div>
        <div class="shareSlogan">{{$t('lang.cashWheel.shareSlogan4')}}</div>
        <div class="shareSlogan">{{$t('lang.cashWheel.shareSlogan5')}}</div>
      </div>
      <div class="shareAwayBox">
        <div class="awayItem" @click.stop="whatsappClick">
          <img class="awayIcon" src="../../assets/images/cashWheel/whatsApp.png"/>
          <div class="awayLabel">Whatsapp</div>
        </div>
        <div class="awayItem" @click.stop="telegramClick">
          <img class="awayIcon" src="../../assets/images/cashWheel/telegram.png"/>
          <div class="awayLabel">Telegram</div>
        </div>
        <div class="awayItem" @click.stop="facebookClick">
          <img class="awayIcon" src="../../assets/images/cashWheel/faceBook.png"/>
          <div class="awayLabel">Facebook</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
export default {
  name: 'modallBox-share',
  props: {
    UsedDrawCount: {
      type: Number,
      default: null
    },
    chance: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      lang: localStorage.getItem('locale'),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      shareCode: '',
      amount1: 0,
      amount2: 0,
      amount3: 0
    }
  },
  watch: {
    '$store.state.locale': function (val) {
      this.lang = val
    }
  },
  mounted () {
    if (!this.userInfo) {
    } else {
      this.fetchAccount()
    }
  },
  methods: {
    fetchAccount () {
      let that = this
      const url = '/innovation/account/getuseraccount'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data).then(res => {
        that.shareCode = res.InviteLink
      }).catch(err => {
        console.log(err)
      })
    },
    fetchLocalAmount () {
      const url = '/innovation/home/get-system-settings'
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      const data = {IsApp: 1, CampaignId: cid}
      request('post', url, data).then(res => {
        this.amount1 = res.SevenDayReward
        this.amount2 = res.InviteeReward
        this.amount3 = res.FirstDepositMaxReward
        this.$store.commit('setInviteeObj',
          {
            sevenDayReward: res.SevenDayReward,
            inviteeMaxReward: res.DefaultCampaignIdFirstDepositMaxReward,
            InviteeReward: res.InviteeReward
          })
        this.$store.commit('setSharingStarIcon', res.InviteRankActivitySwitch)
      }).catch(err => {
        console.log(err)
      })
    },
    close () {
      this.$emit('closeModalBoxShare')
    },
    share () {
      if ((this.UsedDrawCount !== 3) || localStorage.getItem('shareVIRData')) {
        return
      }
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null,
        visitorCode: this.visitorCode
      }
      request('post', 'innovation/virality/share', data, false).then(res => {
        this.$emit('setChanceAndBalance', JSON.stringify({RemainingDrawCount: res.Data.RemainingDrawCount, Balance: res.Data.Balance}))
      })
    },
    msgFormat () {
      let welcomeMessage = this.$t('lang.inviteFriends.inviteMsg')
      let index = this.shareCode.indexOf('/Share')
      if (index === -1) {
        index = this.shareCode.toLowerCase().indexOf('/share')
      }
      if (index !== -1) {
        const pre = this.shareCode.substring(0, index)
        this.shareCode = this.shareCode.replace(pre, 'https://' + location.host)
      }
      // Check if shareType already exists in the shareCode
      if (!this.shareCode.includes('shareType=')) {
        // Append the shareType parameter to the shareCode
        if (this.shareCode.includes('?')) {
          this.shareCode += '&shareType=VIR'
        } else {
          this.shareCode += '?shareType=VIR'
        }
      }
      console.log('sssssss', this.shareCode)
      if (this.lang === 'EN') {
        welcomeMessage = `${this.shareCode} Hey bro! I need a friend to help me and get ₹500 for free! Click to help me, you can also get ₹30+₹77 CASH! And 30% new player bonus! Log in to the game now and earn with me!`
      } else {
        welcomeMessage = `${this.shareCode} हे भाई! मुझे मदद की ज़रूरत है और ₹500 फ्री में प्राप्त करें! मुझे मदद करने के लिए क्लिक करें, आप भी ₹30+₹77 कैश प्राप्त कर सकते हैं! और 30% न्यू प्लेयर बोनस! अब गेम में लॉग इन करें और मेरे साथ कमाई करें!`
      }
      console.log(welcomeMessage)
      return welcomeMessage
    },
    goLogin () {
      localStorage.setItem('isVIRShareLogin', true)
      this.$router.push('/Login')
    },
    telegramClick () {
      if (!this.userInfo) {
        this.goLogin()
        return
      }
      this.saveUserEvent('Telegram')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      this.share()
      window.open(`https://t.me/share/url?text=` + message + `&url=%20`)
    },
    whatsappClick () {
      if (!this.userInfo) {
        this.goLogin()
        return
      }
      this.saveUserEvent('WhatsApp')
      this.copyShares()
      let message = encodeURIComponent(this.msgFormat())
      this.share()
      window.open(`https://wa.me/?text=${message}`, '_blank')
    },
    facebookClick () {
      if (!this.userInfo) {
        this.goLogin()
        return
      }
      let message = encodeURIComponent(this.msgFormat())
      this.saveUserEvent('Facebook')
      this.copyShares()
      this.share()
      window.open(`https://www.facebook.com/sharer.php?u=` + message, '_blank')
    },
    copyShares () {
      let message = this.msgFormat()
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', message)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    // 埋点
    saveUserEvent (val) {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, UserUniqueId: this.userInfo.UserId}
      request('post', url, data).then(res => {
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes slideInFromBottom {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.share{
  height: 122.22vw;
  width: 93.33vw;
  background-color: #242424;
  border-radius: 2vw;
  position: relative;
  top: 20vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: slideInFromBottom 0.2s ease-out forwards;
  .close{
    height: 4.05vw;
    width: 4.05vw;
    position: absolute;
    top: -7vw;
    left: 88vw
  }
  .getFreeBox{
    width: 100%;
    height: 37.2vw;
    border-radius: 2vw 2vw 0 0;
  }
  .titleBox{
    margin-top: 2vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
      font-size: 5.277vw;
      color: #fff;
      font-weight: 700;
    }
  }
  .shareSloganBox{
    height: 27.77vw;
    //width: 85.744vw;
    font-size: 4vw;
    color: #8F8F8F;
    line-height: 6vw;
    margin-top: 5vw;
  }
  .shareAwayBox{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 10vw;
    padding-left: 3vw;
    padding-right: 3vw;
    .awayItem{
      width: 20.55vw;
      height: 23.33vw;
      background-color: #2C2C2E;
      border-radius: 2vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .awayIcon{
        height: 11.94vw;
        width: 11.94vw;
      }
      .awayLabel{
        font-size: 3.05vw;
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modallBox-share.vue